export var IconSizes;
(function (IconSizes) {
    IconSizes["Large"] = "large";
    IconSizes["Medium"] = "medium";
    IconSizes["Small"] = "small";
})(IconSizes || (IconSizes = {}));
export var IconVariants;
(function (IconVariants) {
    IconVariants["Plain"] = "plain";
    IconVariants["Rounded"] = "rounded";
})(IconVariants || (IconVariants = {}));
export var IconColors;
(function (IconColors) {
    IconColors["Primary"] = "primary";
    IconColors["Secondary"] = "secondary";
    IconColors["Danger"] = "danger";
    IconColors["Transparent"] = "transparent";
})(IconColors || (IconColors = {}));
export var IconBackgroundColors;
(function (IconBackgroundColors) {
    IconBackgroundColors["Primary"] = "primary";
    IconBackgroundColors["Secondary"] = "secondary";
})(IconBackgroundColors || (IconBackgroundColors = {}));
